import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadInvoiceIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 11.8994L4.5 6.39941C4.5 4.19028 6.29086 2.39941 8.5 2.39941H16.5C18.7091 2.39941 20.5 4.19028 20.5 6.39941V17.3994C20.5 19.6086 18.7091 21.3994 16.5 21.3994V21.3994",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 6.89941H9.5",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 9.89941H9.5",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.31055 22.5205L7.31055 15.0205L8.81055 15.0205L8.81055 22.5205L7.31055 22.5205Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.5604 19.0205L8.06043 15.5205L4.56043 19.0205L3.49977 17.9598L6.99977 14.4598C7.58556 13.8741 8.53531 13.8741 9.12109 14.4598L12.6211 17.9598L11.5604 19.0205Z",
			fill: "white"
		})
	]
});
export default SvgUploadInvoiceIcon;
